module.exports = __webpack_public_path__ + "img/aeen - logos secundario 1.be4802f9.jpg";